// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__LGa7S","inputWrap":"styles_inputWrap__2lFVG","input":"styles_input__3gZHE"};